module.exports = __webpack_public_path__ + "img/wave-mid.ba75e0c9.png";